import { pagesConfig } from './pagesConfig'

export const US_COMPLIANT_CHECKOUT = 'paycheck1_pr1_v_3'
export const US_COMPLIANT_CHECKOUT_WITH_REVOLUT_PAY = 'paycheck1_pr1_v_3_r'
export const US_COMLAINT_CHECKOUT_WITH_PIX = 'paycheck1_pr1_v_3_p'
export const US_COMLAINT_CHECKOUT_WITH_BLIK = 'paycheck1_pr1_v_3_b'
/** Default for non-US ad traffic when the splitter didn't set another paywall. */
export const NON_US_ADS_CHECKOUT = 'paycheck1_pr1_v'

// TODO: matching a checkout step by its screen id prefix is fragile — any new
//  paywall named outside the `paycheck*` convention silently stops being swapped.
//  Replace with an explicit marker on the page config (e.g. `isCheckout: true`
//  in pagesConfig) once page groups are integrated.
const isCheckoutScreen = (page: string) => page.startsWith('paycheck')

export const defaultPages: string[] = [
  'searching_default',
  'warning_default',
  'lookup_default',
  'report_ready_default',
  'signup_default',
  'paycheck1_pr1_default',
  'success_default',
]

export const flowsList: Record<string, string[]> = {
  default: ['phone_lookup_default', ...defaultPages],
}

export const isPaidAdTraffic = (traffic: { fbclid?: string | null; gclid?: string | null }) =>
  Boolean(traffic.fbclid || traffic.gclid)

/**
 * US, or non-US direct/organic → force US-compliant v3.
 * Non-US paid ads → leave the flow as-is (splitter wins; default is v1).
 */
export const shouldForceUsCompliantCheckout = (
  countryCode: string | null | undefined,
  traffic: { fbclid?: string | null; gclid?: string | null },
) => {
  const isNonUs = Boolean(countryCode && countryCode.toUpperCase() !== 'US')
  return !(isNonUs && isPaidAdTraffic(traffic))
}

/** Swaps whatever checkout step the flow has for the US-compliant one. */
export const applyUsCompliantCheckout = (pages: string[]) =>
  pages.map((page) => {
    if (isCheckoutScreen(page)) {
      if (page === 'paycheck1_pr1_default' || pagesConfig[page]?.componentProps?.ftcPaywall) {
        return page
      }
      if (pagesConfig[page]?.componentProps?.withRevolutPay) {
        return US_COMPLIANT_CHECKOUT_WITH_REVOLUT_PAY
      }
      if (pagesConfig[page]?.componentProps?.isShowPixAutomatico) {
        return US_COMLAINT_CHECKOUT_WITH_PIX
      }
      if (pagesConfig[page]?.componentProps?.isShowBlik) {
        return US_COMLAINT_CHECKOUT_WITH_BLIK
      }
      return US_COMPLIANT_CHECKOUT
    }
    return page
  })
